import React, { useState, memo, useEffect } from "react";
import "./CampClassification.css";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";

import { useNavigate} from "react-router-dom";
import ArrowUp from "@mui/icons-material/ArrowUpward";
import ArrowDown from "@mui/icons-material/ArrowDownward";
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroller";
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper";
import { Config } from "../../../../Utils/Config";

let campSpotlist = [];
const CampClassification = memo((props) => {
  const [totalPage, setTotalPage] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(25);
  const [orderBy, setOrderBy] = useState("proximity");
  const [orderDirection, setOrderDirection] = useState(true);
  const [proxmityDirection, setProxmityDirection] = useState(true);

  const marketId = props && props.marketId ? props.marketId : null;
  const [campClassificationList, setCampClassificationTable] = useState([]);

  //seasonality api
  const getCampClassification = async() => {
    setLoading(true);
    let inputData={marketId: marketId,
        page: page,
        resultsPerPage: rowsPerPage,
        orderBy: orderBy,
        orderDirection: (orderDirection && proxmityDirection) ? "Asc" : "Desc"}
    await  apiCommonTrigger("post",`${Config.API_URL}/markets/market/analysis/classifications`,inputData)
    .then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (page === 1) {
          campSpotlist = [];
          setTotalPage(res.data.pagination.totalpages);
        }
        campSpotlist.push(res.data.profileclasses);
        // setTotalPage(res.data.pagination.totalPages);
        setCampClassificationTable({
          ...campClassificationList,
          campClassificationList:
            res.data.profileclasses.length === 0 ? [] : campSpotlist,
        });
      }else{
        handlingCatchError(res, navigate);
      }
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //clear list when page renders
  useEffect(() => {
    campSpotlist = [];
  }, []);

  //call camping based on the below changes
  useEffect(() => {
    if(page === 1 || page <= totalPage)
    getCampClassification();
  }, [page, orderDirection, proxmityDirection]);


  const handleInfiniteOnLoad = () => {
    setPage(page + 1);
  };

  return (
    <div>
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading loading-center"></div>
        </div>
      ) : (
        ""
      )}
      <div>
        <div className="table-legend">
          <span><b>AAA</b> is A + AA + Additional Features</span>
          <span><b>AA</b> is A + Full Hook up</span>
          <span><b>A</b> is partial hook up + Additional features like a picnic table</span>
          <span><b>B</b> is Partial Electric and Partial Water</span>
          <span><b>C</b> is No Hookups</span>
          <span><b>D</b> is Tent camping (No Vehicular access)</span>
        
        </div>
        <div className="camping-spot table-height">
          <InfiniteScroll
            initialLoad={false}
            loadMore={page !== totalPage ? handleInfiniteOnLoad : ''}
            hasMore={page !== totalPage}
            threshold={20}
            useWindow={false}
          >
            <Table className="table-design">

              <TableHead>
                <TableRow>
                  <TableCell
                    id="sort-amenities"
                    onClick={() => {
                      setPage(1);
                      setProxmityDirection(true);
                      setOrderBy("profilename");
                      setOrderDirection(!orderDirection);
                    }}
                  >
                    Campgrounds {orderDirection ? <ArrowDown /> : <ArrowUp />}
                  </TableCell>
                  <TableCell>Classification</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell onClick={()=> {
                    setPage(1);
                    setProxmityDirection(!proxmityDirection);
                    setOrderBy("proximity");
                    setOrderDirection(true);
                  }}>Proximity (miles) {proxmityDirection ? <ArrowDown /> : <ArrowUp />} </TableCell>
                  <TableCell>URL</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {campClassificationList &&
                campClassificationList.campClassificationList &&
                campClassificationList.campClassificationList.length > 0 ? (
                  campSpotlist.map((camp) =>
                    camp.map((data) => (
                      <TableRow key={data.profileid}>
                        <TableCell>{data.profilename}</TableCell>
                        <TableCell>{data.classification}</TableCell>
                        <TableCell>{[ data.streetaddress1, data.streetaddress2, data.city, data.statecode, data.zipcode ].filter(Boolean).join(", ") || "-"}</TableCell>
                        <TableCell>{data.proximity || "-"}</TableCell>                        
                        <TableCell> { data.website ?  <a href={"http://" + data.website} target="new">  {data.website} </a>   : data.website || '-'}</TableCell>
                      </TableRow>
                    ))
                  )
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={7}
                      style={{ textAlign: "center" }}
                      className="store-no-data"
                    >
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
});

export default CampClassification;
